import { useSession } from "../state";

export function GoogleButton({ label = "continue with google" }: { label?: string }) {
  const { signInWithGoogle } = useSession();
  return (
    <button
      type="button"
      onClick={() => { signInWithGoogle(); }}
      className="w-full inline-flex items-center justify-center gap-3 px-4 py-2.5 rounded-full border border-ink/15 bg-white hover:bg-cream-dark transition font-medium"
    >
      <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden>
        <path d="M17.64 9.2a10.4 10.4 0 0 0-.16-1.84H9v3.48h4.84a4.13 4.13 0 0 1-1.8 2.71v2.26h2.92A8.83 8.83 0 0 0 17.64 9.2z" fill="#4285F4"/>
        <path d="M9 18a8.6 8.6 0 0 0 5.96-2.18l-2.92-2.26a5.4 5.4 0 0 1-8.04-2.83H.96v2.33A9 9 0 0 0 9 18z" fill="#34A853"/>
        <path d="M3.96 10.71A5.4 5.4 0 0 1 3.68 9c0-.59.1-1.16.28-1.71V4.96H.96A9 9 0 0 0 0 9c0 1.45.35 2.83.96 4.04l3-2.33z" fill="#FBBC05"/>
        <path d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 .96 4.96l3 2.33A5.4 5.4 0 0 1 9 3.58z" fill="#EA4335"/>
      </svg>
      {label}
    </button>
  );
}
